import { useEffect, useState } from 'react';
import { useForwardingRef } from '@arc/frontend/util-common';
import { FormControlLength } from '../FormControl';
import { Input } from './Input';
/**
 * Input with helper text displaying current length of the input value.
 * Sets error when length is past the max length.
 *
 * NOTE: Expects current input value to be passed in via `value` prop
 */
export function InputTextFieldLength({
  label,
  helperText,
  error,
  outerStyle,
  maxLength,
  inputRef: inputRefProp,
  ...other
}) {
  const inputRef = useForwardingRef(null, [inputRefProp]);
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    // Using onFocus/onBlur on the input element does not work as expected
    const clickHandler = e => {
      setIsFocused(inputRef.current === e.target);
    };
    document.addEventListener('click', clickHandler);
    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, [inputRef]);
  return <FormControlLength label={label} helperText={helperText} error={error} outerStyle={outerStyle} value={other.value} maxLength={maxLength} forceShowLength={isFocused}>
			<Input inputRef={inputRef} error={error} {...other} />
		</FormControlLength>;
}